import React from "react";

interface ArrowRightProps {
  color?: string;
}

const ArrowRight: React.FC<ArrowRightProps> = ({ color = "#086D33" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6.6665L15 12.6665L9 18.6665"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRight;
